module.exports = __webpack_public_path__ + "img/dz.15afdd2f.png";